import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';
import { ValidatedTextField } from 'components';

import Tip from 'components/Tip';

const Title: FC = () => {
  const { t } = useTranslation();

  return (
    <Grid container>
      <Grid item xs={3}>
        <Typography variant="subtitle2">{t('common:title')}</Typography>
      </Grid>
      <Grid item xs={9}>
        <ValidatedTextField
          name="title"
          i18nKey="contentEmails:titlePlaceholder"
          color="primary"
          TextFieldProps={{ margin: 'none', label: null }}
        />
        <Tip i18nKey="contentEmails:titleTip" />
      </Grid>
    </Grid>
  );
};

export default Title;
